import React from 'react';
import { Section } from './ui/Section';
import { Mail, Github, Linkedin, Twitter, ArrowUpRight } from 'lucide-react';
const socialLinks = [{
  name: 'Email',
  value: 'contact@macs.dev',
  href: 'mailto:contact@macs.dev',
  icon: Mail,
  color: 'hover:text-blue-400 hover:border-blue-400/30'
}, {
  name: 'LinkedIn',
  value: 'in/macsdickinson',
  href: 'https://www.linkedin.com/in/macsdickinson/',
  icon: Linkedin,
  color: 'hover:text-blue-600 hover:border-blue-600/30'
}, {
  name: 'GitHub',
  value: '@macsdickinson',
  href: 'https://github.com/macsdickinson',
  icon: Github,
  color: 'hover:text-purple-400 hover:border-purple-400/30'
}, {
  name: 'X (Twitter)',
  value: '@macsdickinson',
  href: 'https://x.com/macsdickinson',
  icon: Twitter,
  color: 'hover:text-sky-400 hover:border-sky-400/30'
}];
export function Contact() {
  return <Section id="contact" className="py-24 md:py-32 border-t border-border/20 relative" data-id="element-40">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background/50 pointer-events-none" data-id="element-41" />

      <div className="max-w-5xl mx-auto" data-id="element-42">
        <div className="text-center mb-16 space-y-6" data-id="element-43">
          <h2 className="text-4xl md:text-6xl font-bold tracking-tight text-foreground" data-id="element-44">
            Let's Connect
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto" data-id="element-45">
            Always happy to discuss engineering leadership, platform strategy,
            or speaking opportunities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-46">
          {socialLinks.map((link, index) => <a key={index} href={link.href} target="_blank" rel="noopener noreferrer" className={`group flex items-center justify-between p-6 rounded-2xl bg-card/80 dark:bg-white/5 border border-border/50 dark:border-white/10 backdrop-blur-sm transition-all duration-300 hover:bg-card dark:hover:bg-white/10 shadow-sm hover:shadow-md ${link.color}`} data-id="element-47">
              <div className="flex items-center gap-4" data-id="element-48">
                <div className="p-3 rounded-xl bg-secondary/50 dark:bg-black/20 text-muted-foreground group-hover:text-foreground transition-colors" data-id="element-49">
                  <link.icon size={24} data-id="element-50" />
                </div>
                <div data-id="element-51">
                  <div className="text-sm text-muted-foreground font-medium mb-0.5" data-id="element-52">
                    {link.name}
                  </div>
                  <div className="text-lg font-bold text-foreground" data-id="element-53">
                    {link.value}
                  </div>
                </div>
              </div>
              <ArrowUpRight className="text-muted-foreground opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-54" />
            </a>)}
        </div>

        <div className="pt-24 flex flex-col md:flex-row justify-between items-center text-sm text-muted-foreground border-t border-border/20 mt-16" data-id="element-55">
          <p data-id="element-56">&copy; {new Date().getFullYear()} Macs Dickinson.</p>
          <div className="flex gap-6 mt-4 md:mt-0" data-id="element-57">
            <span data-id="element-58">
              Built with <span className="text-red-900" data-id="element-59">♥</span> in the UK
            </span>
          </div>
        </div>
      </div>
    </Section>;
}